import React from 'react';

const SidebarMenuFacebookLoader = () => {
  return (
    <div className="brand-sidebar w-80 min-h-screen p-3 space-y-2 animate-pulse">
      {[...Array(12)].map((_, i) => (
        <div key={i} className="flex items-center space-x-3 p-2 rounded-md">
          <div className="w-5 h-5 bg-gray-300 rounded"></div>
          <div className="h-3 w-32 bg-gray-300 rounded"></div>
        </div>
      ))}
    </div>
  );
};

export default SidebarMenuFacebookLoader;
